type CampaignAccess =
  'campaign-complete' | 'category-complete' | 'chapter-complete' | 'locked' | 'missing' | 'available';

export const getCampaignRedirect = (access: CampaignAccess, categoryId?: string, chapterRoute = false) => {
  if (access === 'available') return undefined;
  if (access === 'campaign-complete') return { to: '/play' as const };
  if (access === 'category-complete' || !chapterRoute || !categoryId) return { to: '/play/campaigns' as const };
  return { to: '/play/campaigns/$categoryId' as const, params: { categoryId } };
};
